/**
 * 中文翻译
 */

const zhTranslations = {
    app: {
        title: '书签浏览器',
        allBookmarks: '全部书签',
    },
    sidebar: {
        title: '文件夹',
        empty: '暂无文件夹',
        myBookmarks: '我的书签',
        favorites: '收藏夹',
        readingList: '稍后阅读',
        trash: '回收站',
        folders: '文件夹',
        user: '本地用户',
        localMode: '本地模式',
    },
    toolbar: {
        new: '新建',
        newFolder: '新建文件夹',
        newBookmark: '新建书签',
        import: '导入',
        export: '导出',
        manage: '管理',
        delete: '删除',
        selection: '选择',
        selectionMode: '选择模式',
        selectAll: '全选',
        clearSelection: '取消选择',
        invertSelection: '反向选择',
        undo: '撤销',
        redo: '重做',
        sort: '排序',
        sortBy: '排序方式',
        sortDefault: '默认顺序',
        sortByName: '名称',
        sortByDate: '修改日期',
        sortByType: '类型',
        order: '顺序',
        ascending: '递增',
        descending: '递减',
        view: '视图',
    },
    viewMode: {
        list: '列表视图',
        card: '卡片视图',
        tile: '平铺视图',
    },
    settings: {
        title: '设置',
        appearance: '外观',
        behavior: '行为',
        theme: '主题',
        language: '语言',
        autoExpandTree: '自动展开目录树',
        singleClickAction: '单击行为',
        singleClickSelect: '单击选中',
        singleClickOpen: '单击打开',
        cardColumns: '卡片视图列数',
        tileColumns: '平铺视图列数',
        columnsDesktop: '电脑',
        columnsMobile: '手机',
        cardFolderPreviewSize: '文件夹预览尺寸',
        defaultView: '默认视图',
        rememberFolderView: '记忆文件夹视图',
        themeColor: '主题色',
        customColor: '自定义颜色',
        clearData: '清除数据',
        clearDataDescription: '清除全部书签、文件夹、收藏与设置，此操作不可撤销。',
    },
    theme: {
        light: '浅色',
        dark: '深色',
        system: '跟随系统',
    },
    language: {
        zh: '中文',
        en: 'English',
    },
    inspector: {
        title: '属性',
        preview: '预览',
        name: '名称',
        url: '网址',
        color: '颜色',
        notes: '备注',
        type: '类型',
        created: '创建时间',
        updated: '修改时间',
        folder: '文件夹',
        bookmark: '书签',
        changeCover: '更换封面',
        fetchMetadata: '自动获取',
        pasteUrl: '粘贴图片链接...',
        close: '关闭',
        customColor: '自定义颜色',
    },
    search: {
        placeholder: '搜索书签...',
        noResults: '未找到相关书签',
        scopeAll: '全部',
        scopeCurrent: '当前文件夹',
    },
    empty: {
        title: '暂无内容',
        description: '点击上方按钮创建文件夹或书签',
        noBookmarks: '暂无书签',
    },
    content: {
        subfolders: '子文件夹',
        bookmarks: '书签',
        items: '个项目',
    },
    contextMenu: {
        open: '打开',
        openInNewTab: '在新标签页打开',
        rename: '重命名',
        delete: '删除',
        moveTo: '移动到...',
        copyUrl: '复制链接',
        edit: '编辑',
    },
    dialog: {
        confirm: '确认',
        cancel: '取消',
        save: '保存',
        delete: '删除',
        deleteConfirm: '确定要删除选中的 {{count}} 个项目吗？',
        deleteWarning: '此操作无法撤销',
        clearData: '清除数据',
        clearDataConfirm: '即将清除浏览器中保存的全部书签、文件夹、收藏与设置。',
        clearDataSaveWarning: '如需保留书签，请先通过「导入 / 导出」保存为 HTML 文件。',
    },
    import: {
        title: '导入书签',
        selectFiles: '选择文件',
        dropHint: '拖放 HTML 文件到这里',
        targetFolder: '导入到',
        currentFolder: '当前文件夹',
        selectFolder: '选择文件夹',
        importing: '正在导入...',
        success: '导入成功',
        created: '已创建 {{count}} 个项目',
        errors: '有 {{count}} 个错误',
    },
    export: {
        title: '导出书签',
        all: '全部书签',
        currentFolder: '当前文件夹',
        selection: '选中项目',
        exporting: '正在导出...',
        success: '导出成功',
    },
    error: {
        unknown: '未知错误',
        networkError: '网络错误',
        corsBlocked: '无法访问该网站（CORS 限制）',
        fetchTimeout: '请求超时',
        invalidUrl: '无效的网址',
        storageFull: '存储空间已满',
    },
    selection: {
        selected: '已选择',
        favorite: '收藏',
        readLater: '稍后',
        restore: '恢复',
        deletePermanent: '永久删除',
        delete: '删除',
    },
    toast: {
        copied: '已复制到剪贴板',
        saved: '已保存',
        deleted: '已删除 {{count}} 个项目',
        deletedPermanent: '已永久删除 {{count}} 个项目',
        moved: '已移动',
        renamed: '已重命名',
        undo: '撤销',
        favorited: '已添加到收藏夹',
        unfavorited: '已从收藏夹移除',
        readLaterAdded: '已添加到稍后阅读',
        readLaterRemoved: '已从稍后阅读移除',
        restored: '已恢复 {{count}} 个项目',
        exportSelectionEmpty: '请先选择要导出的项目',
        cleared: '已清除全部数据',
    },
    aria: {
        toggleSidebar: '切换侧边栏',
        toggleInspector: '切换属性面板',
        switchLanguage: '切换语言',
        switchTheme: '切换主题',
        clearSearch: '清除搜索',
        breadcrumbOverflow: '显示省略的路径',
        listView: '列表视图',
        cardView: '卡片视图',
        tileView: '平铺视图',
        close: '关闭',
        expand: '展开',
        collapse: '收起',
        skipToContent: '跳到主要内容',
        openSettings: '打开设置',
        resizeSidebar: '调整侧边栏宽度',
        resizeInspector: '调整属性面板宽度',
    },
};

export type Translation = typeof zhTranslations;

export default zhTranslations;
